import React from "react";
import {TwitterShareButton} from 'react-share';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  typography: {
    paddingLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
});

class TweetButton extends React.Component {

  render() {
    const { classes } = this.props;
    return (<div>
      <Typography component="h6" variant="h6" style={{size:"18px"}} className={classes.typography}>
        このサイトが役に立ったらシェアお願いします
      </Typography>
      <Paper className={classes.paper}>
        <TwitterShareButton
          url={"https://buster.poyashi.me/"}
          title={"クソリプバスター : Twitterブロックリストの作成を効率化"}
          style={{color:"#3f51b5",cursor:"pointer",display:"inline-block"}}>
          Twitterでシェア
        </TwitterShareButton>
      </Paper>
    </div>
    );
  }
}

export default withStyles(styles)(TweetButton);
